/* The data loader + document-level wiring, ported from init() (app.ts ~5368).
   init() did four things before/around the fetches: wired the hamburger,
   wired the Escape stack, delegated every ⓘ panel's "More in About Hermes"
   handoff, and launched the fault-isolated load groups. In React the hamburger
   and scrim are wired by the components that render them (Hero, Drawer); this
   hook owns the two GLOBAL document listeners (Escape, concept-more) and kicks
   off store.load(). Runs once per mount (StrictMode's double-invoke is guarded
   by the store's own `loaded` latch and by the cleanup that removes listeners). */
import { useEffect } from "react";
import { useStore } from "./store";

export function useHermesData(): void {
  const store = useStore();
  useEffect(() => {
    /* Escape backs out of the topmost surface only: the picker sits over the
       Explore menu, which sits over the drawer (section-navigator N3/N10). */
    const onKey = (e: KeyboardEvent): void => {
      if (e.key !== "Escape") return;
      const s = store.state;
      if (s.pickerOpen) return store.closePicker();
      if (s.openMenu) return store.toggleMenuBar(s.openMenu);
      if (s.menuOpen) store.toggleMenu(false);
    };
    /* every ⓘ panel's "More in About Hermes" hands off through one delegated
       listener — the panels render inside help HTML all over the app, and
       delegation survives every repaint (help-layer.md HL2) */
    const onClick = (e: MouseEvent): void => {
      const target = e.target;
      if (target instanceof HTMLElement && target.classList.contains("concept-more"))
        store.selectNav("about-hermes");
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("click", onClick);
    void store.load();
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("click", onClick);
    };
    /* store is stable for the app's life (a ref) — an empty dep list is correct */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
